import { useContext } from 'react';
//
import { AuthContext } from 'src/contexts/CommonJWTContext';

// ----------------------------------------------------------------------

const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) throw new Error('Common Auth context must be use inside Common AuthProvider');

  return context;
};

export default useAuth;
